import * as Yup from "yup";

import { ApproveOfferForm, ApproveTreatyForm } from "components/forms";
import {
  ApproveTreaty,
  ApproveTreatyVariables,
} from "_graphql/mutation/kek/__generated__/ApproveTreaty";
import { Modal, OfficeButton } from "components";
import {
  SetApprovalStatus,
  SetApprovalStatusVariables,
} from "_graphql/mutation/kek/__generated__/SetApprovalStatus";
import {
  approveOffer,
  setTreatyApprovalStatus,
} from "_graphql/kek/mutation/index.kek";
import { useAppLocation, useAppSearch } from "_graphql/cache/auth";

import _ from "lodash";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useKEKOffer } from "hooks/data/use-offers";
import { useMutation } from "@apollo/client";
import { useOfferComments } from "hooks/data/use-offer-comments";
import { useTreaty } from "hooks/data/use-treaties";
import { withPermissions, wrapClick } from "utils";

export default function ApproveTreatyContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParam = useAppSearch();
  const { params } = useAppLocation();
  const { treaty, loading } = useTreaty({ treatyId: searchParam?.id || "" });
  const { comments, loading: loadingComments } = useOfferComments({
    offerId: searchParam?.id || "",
  });
  const [setStatus, { loading: settingStatus }] = useMutation<
    ApproveTreaty,
    ApproveTreatyVariables
  >(setTreatyApprovalStatus, {
    refetchQueries: ["GetKEKTreaties"],
  });
  const form = useFormik<any>({
    initialValues: {
      status: "",
      message: "",
      approval_date: "",
    },
    onSubmit: async (variables) => {
      setStatus({
        variables: {
          document_message: [variables?.message],
          treaty_id: searchParam?.id || "",
          approval_date: variables?.approval_date || "",
          approval_status: variables?.status || "",
        },
      })
        .then(() => {
          toast.success("Offer status changed successfully!");
          setOpen?.(false);
        })
        .catch((error) => {
          console.error("Error changing offer status:", error);
          toast.error("Failed to change offer status.");
        });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading || loadingComments}
      title="Approve Treaty"
      description="Review and approve the treaty details before proceeding."
      renderActions={() => (
        <>
          {withPermissions([
            "*:*",
            "treaties:*",
            "treaties:manage",
            "treaties:approve",
          ])(
            <OfficeButton
              disabled={settingStatus}
              onClick={wrapClick(form.handleSubmit)}
            >
              {settingStatus ? "Submitting..." : "Submit"}
            </OfficeButton>
          )}
        </>
      )}
    >
      <ApproveTreatyForm form={form} treaty={treaty} comments={comments} />
    </Modal>
  );
}
